import { render, staticRenderFns } from "./invoiceMaker.vue?vue&type=template&id=4fd586d0&scoped=true"
import script from "./invoiceMaker.vue?vue&type=script&lang=js"
export * from "./invoiceMaker.vue?vue&type=script&lang=js"
import style0 from "./invoiceMaker.vue?vue&type=style&index=0&id=4fd586d0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd586d0",
  null
  
)

export default component.exports